import React from "react";
import { Button, Form, Heading, Modal, TextInput } from "blueprints2";
import { FormattedMessage } from "react-intl";

function EditCredential({
  visible,
  setVisible,
  values,
  change,
  editCred,
  error,
}) {
  return (
    <Modal
      isVisible={visible}
      onClose={() => setVisible(false)}
      className="w-1/4"
    >
      <Heading level={3}>
        <FormattedMessage id="applications.form.edit.title" />
      </Heading>
      <Form
        className="w-full"
        values={values}
        onChange={(e) => change(e)}
        onSubmit={(e) => editCred(e)}
      >
        <TextInput
          label={<FormattedMessage id="applications.form.name" />}
          name="name"
          hasError={!!error}
          helperText={error}
        />

        <TextInput
          isDisabled
          label={<FormattedMessage id="applications.form.client_id" />}
          name="clientId"
        />
        <TextInput
          isDisabled
          label={<FormattedMessage id="applications.form.client_secret" />}
          name="clientSecret"
        />
        <Button type="submit">
          <FormattedMessage id="applications.form.edit.save" />
        </Button>
        <Button isSecondary onClick={() => setVisible(false)}>
          <FormattedMessage id="applications.form.cancel" />
        </Button>
      </Form>
    </Modal>
  );
}

export default EditCredential;
